<template>
  <div class="login-component">
    <div class="title-width">
      <div v-if="title" style="margin-bottom:1rem;">{{ title }}</div>
      <!--
      <div :class="message ? {alert:true, 'alert-danger':true} : {}" role="alert">{{message}}</div>
      -->
      <div style="padding-bottom: 20px" v-if="$root.account.isLogin">{{ $root.account.info.userName }}としてログイン中です。</div>

    </div>
    <div v-if="requestMessage" style="padding: 0px 40px 20px;">
      <div style="border: 1px solid #ddd;padding: 8px 12px;background-color: #fafafa;">{{requestMessage}}</div>
    </div>

    <div class="input-width">
        <form>
          <div class="form-group" style="margin-bottom: 0">
            <label for="nameInput">{{ $root.messages.login.mail }}</label>
            <input
              class="form-control"
              id="nameInput"
              name="username"
              type="email"
              v-model="formLogin.name"
              @keyup.enter="submitLogin"
              autocomplete="email"
              autofocus
            />
          </div>
          <div class="password-wrap">
              <label for="passwordInput">{{ $root.messages.login.password }}</label>
              <input
                class="form-control"
                id="passwordInput"
                type="password"
                v-model="formLogin.password"
                @keyup.enter="submitLogin"
                autocomplete="current-password"
              />
          </div>
        </form>
    </div>
    <div class="alert alert-danger center-in-flex" v-if="hasLoginError">
      <small>メールアドレスまたはパスワードが正しくありません</small>
    </div>
    
    <div class="check-wrap">
      <div class="form-check" style="padding-left: 0">
        <input id="loginCheck" type="checkbox" v-model="formLogin.rememberMe" class="form-checkbox" />
        <label class="form-check-label" for="loginCheck" style="padding-left: 4px">{{ $root.messages.login.keep }}</label>
      </div>
    </div>

    <div class="input-width">
      <button class="btn btn-primary login-button" @click="submitLogin">ログイン</button>
    </div>
    <div style="padding-top: 1.5rem">
      <router-link @click="onClickLink" :target="linkTarget" to="/forgot/password/">{{ $root.messages.login.resetPassword }}</router-link>
    </div>

    <div class="sign-up-link">
      <router-link @click="onClickLink" :target="linkTarget" to="/signup">
        <span>{{ $root.messages.login.toregistration }}</span>
      </router-link>
    </div>
    
  </div>
</template>

<style lang="scss" scoped>
.login-component{
  min-width: 320px;
  max-width: 640px;
  width: 80vw;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
  padding:3.5rem 0;
  
  @media (max-width: 768px) {
    padding:2.5rem 0;
  }
  @media (max-width: 576px) {
    padding:2rem 0;
  }
  @media (max-width: 480px) {
    padding:1.5rem 0;
  }
  @media (max-width: 380px) {
    padding:0.8rem 0;
  }
}

.password-wrap{
  margin: 1rem 0;
  @media (max-width: 768px) {
    margin: 0.9rem 0;
  }
  @media (max-width: 576px) {
    margin: 0.8rem 0 0.7rem;
  }
  @media (max-width: 480px) {
    margin: 0.7rem 0 0.5rem;
  }
  @media (max-width: 380px) {
    margin: 0.6rem 0 0.3rem;
  }
}

.check-wrap{
  margin-bottom: 1rem;
  @media (max-width: 768px) {
    margin-bottom: 0.9rem;
  }
  @media (max-width: 576px) {
    margin-bottom: 0.7rem;
  }
  @media (max-width: 480px) {
    margin-bottom: 0.6rem;
  }
  @media (max-width: 380px) {
    margin-bottom: 0.4rem;
  }
}

.title-width{
  min-width: 300px;
}
.input-width{
  width: 300px;
}
.login-button{
  margin-bottom: 10px;
  width: 100%;
  @media (max-width: 768px) {
    margin-bottom: 8px;
  }
  @media (max-width: 576px) {
    margin-bottom: 6px;
  }
  @media (max-width: 480px) {
    margin-bottom: 4px;
  }
}

.sign-up-link{
  padding-top: 0.25rem;
  @media (max-width: 768px) {
    padding-top: 0.2rem;
  }
  @media (max-width: 576px) {
    padding-top: 0.15rem;
  }
  @media (max-width: 480px) {
    padding-top: 0.1rem;
  }
}

label {
    display: inline-block;
    margin-bottom: .2rem;
  @media (max-width: 480px) {
    margin-bottom: .1rem;
  }
}
</style>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import LoginForm from "@/interface/api/LoginForm";
import LoginResultResp from "@/interface/api/LoginResultResp";
import DialogFrame from "./dialog/DialogFrame.vue";
import { FMRequestLogin } from '@/interface/kiwi/ForkstyleMessage';

//全てのログインダイアログ間（別々に定義された<LoginDialog>間）で入力値を共通化したいので、クラス外でインスタンス化
const formLogin = {
  name: "",
  password: "",
  rememberMe: true,
} as LoginForm;

@Options({
  components: { DialogFrame },
  props: {
    title: {
      type: String,
    },
    requestLogin:{
      type:Object
    },
  },
  emits: ['on-click-link', 'user-logined'],
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  
  readonly requestLogin!: FMRequestLogin;

  get requestMessage(){
    if(this.requestLogin){
      const arr = []
      if(this.requestLogin.toLoadUserInfo) arr.push("ユーザ情報の読込")
      if(this.requestLogin.toWriteStorage) arr.push("データ書込")
      if(this.requestLogin.toAwardBadge) arr.push("バッチの贈呈")

      if(arr.length){
        return "投稿されたプロジェクトより、" + arr.join("、") + "のためログインを要求されました"
      }else{
        return "投稿されたプロジェクトよりログインを要求されました"
      }
    }else{
      return ""
    }
  }

  get linkTarget(){
    //home画面以外ではタブを開く
    return this.$route.fullPath === "/" ? '' : '_blank'
  }

  public clearInput() {
    //間違ってダイアログ閉じた場合に、再入力面倒だと思うので、パスワードだけ消しておく。
    // this.formLogin.name = "";
    this.formLogin.password = "";
    // this.hasLoginError = false;
  }

  formLogin = formLogin;

  hasLoginError = false;

  submitLogin() {
    // console.log("submitLogin", this.formLogin);
    this.hasLoginError = false;
    this.$root.restAccess
      .postLogin(this.formLogin)
      .then((loginResult: LoginResultResp) => {
        //ログイン後、CSRFトークンを更新する
        window.csrfToken = loginResult.csrfToken

        this.$root
          .account.reload()
          .then(() => {
            this.formLogin.name = "";
            this.formLogin.password = "";
            this.$root.nortifyAccountChangeToBrowserTabs();
            this.$emit("user-logined");
          })
          .catch((_e) => {
            //todo: 本来ここに来てはいけない。時間を置いた無限リロードを実装しよう。
            //ここに来てしまうと表示上、ログイン前の状態が維持されてしまうが、一旦仕方ない。
            //勝手にリロードすると作業中の内容を失うかも知れないので、表示がおかしいのを受け入れる。（サーバーが落ちていたらリロードもできないし）
          });
      })
      .catch((e) => {
        if (process.env.VUE_APP_MODE === "development") {
          console.log("ログインに失敗しました", e);
        }
        this.hasLoginError = true;
      });
  }

  onClickLink(e:MouseEvent) {
    if(e.ctrlKey){
      return;
    }
    if(!this.linkTarget){
      this.$emit("on-click-link");
    }
  }

  created() {
    //モバイルでinputにフォーカスするとキーボードが画面を占拠するため
    if(!this.$root.isMobile){
      this.$root.focus("nameInput");
    }
  }
}
</script>